import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
import {remCalc} from '../../../../theme/_utils'

const HorizontalLineIcon = (props) => {
    return (
        <Icon viewBox="0 0 30 1" data-testid="horizontal-line-icon" aria-hidden="true" {...props}>
            <line
                x1="0"
                y1="0.5"
                x2="50"
                y2="0.5"
                stroke="currentColor"
                strokeWidth={remCalc(1)}
                fill="none"
            />
        </Icon>
    )
}

HorizontalLineIcon.propTypes = {
    color: PropTypes.string,
}

export default HorizontalLineIcon
